import React from "react";
import { CircleAlert, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";

export function FailedStep({ error, onRetry }) {
  const { t } = useTranslation();

  return (
    <KycStep labelledBy="kyc-failed-title" className="kyc-status-step">
      <div className="flex min-h-[42dvh] flex-col items-center justify-center py-4 text-center">
        <span className="flex size-16 items-center justify-center rounded-2xl bg-red-50 text-red-700 ring-1 ring-red-100">
          <CircleAlert className="size-7" aria-hidden="true" />
        </span>
        <h1
          id="kyc-failed-title"
          className="mt-7 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950"
        >
          {t("kyc.failed.title")}
        </h1>
        <p className="mt-3 max-w-md text-sm leading-6 text-slate-600">
          {error || t("kyc.failed.description")}
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-7 inline-flex min-h-12 w-full max-w-sm items-center justify-center gap-2 rounded-lg bg-teal-700 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-800 active:scale-[0.99]"
        >
          <RotateCcw className="size-4" aria-hidden="true" />
          {t("kyc.failed.retry")}
        </button>
      </div>
    </KycStep>
  );
}
